export default "__VITE_ASSET__Bd$sTCp9__"